import { PrePackType } from '@epicuro-next/state/config-strip-state';

export const countPrepackItems = (
  prepack: Partial<PrePackType>,
  quantity: number,
): number => {
  return (
    quantity *
    (prepack?.quantities ?? []).reduce((sum, item) => sum + item.quantity, 0)
  );
};
